import React, { useCallback, useState } from 'react';
import {
    Title,
} from 'ui-library';
import { useManagerProfile } from 'prodivers/managerProfile';
import findSpecificFeeData from 'widgets/FeesOverview/hooks/findSpecificFeeData';
import { FEE_TYPES } from 'datasource/CreatePortfolio/constants';
import AssetFee from './components/AssetFee/AssetFee';
import CustodyFee from './components/CustodyFee/CustodyFee';
import CustodyFeeModal from './components/CustodyFeeModal/CustodyFeeModal';
import AssetFeeModal from './components/AssetFeeModal/AssetFeeModal';
import EntryCostFee from './components/EntryCostFee/EntryCostFee';
import AdministrationFees from './components/AdministrationFees';
import AdministrationFeeModal from './components/AdministrationFeeModal/AdministrationFeeModal';

import './fees-overview-base.css';

const FeesOverviewBase = ({
    t,
    feeData,
    defaultCustodyFee,
    defaultAssetFee,
    defaultEntryFee,
    saveFeeLocally,
    isZivAzp,
    isZic,
    is3ap,
    defaultAdministrationFee,
}) => {
    const [showFeeModal, setShowFeeModal] = useState(false);
    const [showAssetModal, setShowAssetModal] = useState(false);
    const [showAdministrationFeeModal, setShowAdministrationFeeModal] = useState(false);
    const { hasAccessPolicy, isPolicyLoading } = useManagerProfile();

    const disableEdit = useCallback((policy) => {
        // IF user does not have acces policy or its zic product

        if (isZic || isPolicyLoading || !hasAccessPolicy(policy)) {
            return true;
        }

        return false;
    }, [isZic, hasAccessPolicy, isPolicyLoading]);

    return (
        <div className="fi-verticals">
            <div>
                <Title type={2}>{t('custodyFee.labels.title')}</Title>
                <div className="FeeOverview__GridWrapper">
                    {is3ap || (
                        <CustodyFee
                            t={t}
                            custodyFee={findSpecificFeeData(FEE_TYPES.custody, feeData)?.fee}
                            defaultCustodyFee={defaultCustodyFee}
                            setShowFeeModal={setShowFeeModal}
                            disableEdit={disableEdit('EnableEditCustodyFee')}
                        />
                    )}
                    {isZivAzp && (
                        <AssetFee
                            t={t}
                            assetFee={findSpecificFeeData(FEE_TYPES.asset, feeData)?.fee}
                            defaultAssetFee={defaultAssetFee}
                            setShowAssetModal={setShowAssetModal}
                            disableEdit={disableEdit('EnableEditAssetFee')}
                        />
                    )}
                    {isZic && (
                        <EntryCostFee
                            defaultEntryFee={defaultEntryFee}
                            t={t}
                        />
                    )}

                    {is3ap && (
                        <AdministrationFees
                            t={t}
                            AdministrationFee={findSpecificFeeData(FEE_TYPES.administration, feeData)?.fee}
                            defaultFee={defaultAdministrationFee}
                            setShowAdministrationFeeModal={setShowAdministrationFeeModal}
                            disableEdit={disableEdit('AdministrationFeeChange3aPremium')}
                        />
                    )}
                </div>

                <CustodyFeeModal
                    showModal={showFeeModal}
                    handleClose={() => setShowFeeModal(false)}
                    onSave={saveFeeLocally}
                    feeData={findSpecificFeeData(FEE_TYPES.custody, feeData)}
                    defaultCustodyFee={defaultCustodyFee}
                />
                <AssetFeeModal
                    showModal={showAssetModal}
                    handleClose={() => setShowAssetModal(false)}
                    onSave={saveFeeLocally}
                    feeData={findSpecificFeeData(FEE_TYPES.asset, feeData)}
                    defaultAssetFee={defaultAssetFee}
                />
                <AdministrationFeeModal
                    showModal={showAdministrationFeeModal}
                    handleClose={() => setShowAdministrationFeeModal(false)}
                    onSave={saveFeeLocally}
                    feeData={findSpecificFeeData(FEE_TYPES.administration, feeData)}
                    defaultAdministrationFee={defaultAdministrationFee}
                />
            </div>
        </div>
    );
};

export default FeesOverviewBase;
